<template>
<el-card>
  <template v-slot:header>
    <div>
      <span class="mr-[40px]">人员管理</span>
    </div>
  </template>

  <div class="mb-[10px] flex flex-row">
    <div class="flex-1 flex flex-row items-center">
      <span class="mr-[10px] whitespace-nowrap overflow-hidden overflow-ellipsis">查找人员</span>
      <el-input class="flex-1" placeholder="输入姓名、手机号、工号" maxlength="32" v-model="searchItem.staff" @keyup.enter.native="find()"></el-input>
    </div>
    <div class="flex-1 flex flex-row items-center">
      <span class="ml-[15px] mr-[10px] whitespace-nowrap overflow-hidden overflow-ellipsis">所属部门</span>
      <el-select v-model="searchItem.department" class="flex-1" placeholder="请选择所属部门">
        <el-option class="text-600" key="" label="所有部门" value=""></el-option>
        <el-option
          v-for="department in departments"
          :key="department.id"
          :label="department.name"
          :value="department.id"
        ></el-option>
      </el-select>
    </div>
    <div class="flex-1 flex flex-row items-center">
      <span class="ml-[15px] mr-[10px] whitespace-nowrap overflow-hidden overflow-ellipsis">人员角色</span>
     <el-select v-model="searchItem.role" class="flex-1" placeholder="请选择角色">
        <el-option class="text-600" key="" label="所有角色" value=""></el-option>
        <el-option
          v-for="(role, index) in roles"
          :key="index"
          :label="role.label"
          :value="role.value"
        ></el-option>
      </el-select>
    </div>
    <div class="flex flex-row ml-[20px]">
      <el-button type="primary" @click="find()">查找</el-button>
      <el-button @click="reset()">重置</el-button>
    </div>
  </div>
  <div class="h-[10px] bg-[#f2f3f5]"></div>
    <div class="flex flex-row pt-[5px] pb-[10px]">
    <el-button type="primary" @click="add()">添加成员</el-button>
    <el-button disabled>分配角色</el-button>
    <el-button disabled>转交任务</el-button>
    <el-button disabled>离职删除</el-button>
  </div>
  <el-table ref="multipleTable" :data="users" border @selection-change="handleSelectionChange">
    <!-- <el-table-column type="selection" width="55"></el-table-column> -->
    <el-table-column fixed prop="index" label="序号" width="70" type="index">
      <!-- <template v-slot="{row}">
        <div class="whitespace-nowrap overflow-hidden overflow-ellipsis">{{ row.index }}</div>
      </template> -->
    </el-table-column>
    <el-table-column prop="psnName" label="姓名/昵称" width="150">
      <template v-slot="{ row }">
        <span>{{row.psnName}}</span><span v-if="row.memberName !== ''"> ({{row.memberName}})</span>
      </template>
    </el-table-column>
    <el-table-column prop="mobile" label="手机号" width="130">
      <template v-slot="{row}">
        <div class="whitespace-nowrap overflow-hidden overflow-ellipsis">{{ row.psnAccount.accountMobile }}</div>
      </template>
    </el-table-column>
    <el-table-column prop="employeeNum" label="工号" width="120">
      <template v-slot="{row}">
        <div class="whitespace-nowrap overflow-hidden overflow-ellipsis">{{ row.employeeNum }}</div>
      </template>
    </el-table-column>
    <el-table-column prop="role" label="角色">
      <template v-slot="{row}">
        <div class="whitespace-nowrap overflow-hidden overflow-ellipsis">{{ filterRole(row.role) }}</div>
      </template>
    </el-table-column>
    <el-table-column prop="status" label="实名状态"  width="80">
      <div class="whitespace-nowrap overflow-hidden overflow-ellipsis">
        <span class="text-[#32D56E]">已实名</span>
      </div>
      
      <!-- <template v-slot="{row}">
        <div class="whitespace-nowrap overflow-hidden overflow-ellipsis">
          <span v-if="row.status === 0" class="text-[#F56C6C] font-bold">未认证</span>
          <span v-else-if="row.status === 1" >已认证</span>
          <span v-else-if="row.status === 2" class="text-[#F56C6C] font-bold">已冻结</span>
        </div>
      </template> -->
    </el-table-column>
    <el-table-column fixed="right" label="操作" width="160">
      <template v-slot="{row}">
        <el-button @click="edit(row)" type="primary" size="mini">编辑</el-button>
        <el-button @click="remove(row)" type="danger" size="mini">删除</el-button>
      </template>
    </el-table-column>
  </el-table>

  <el-pagination
    class="text-center"
    layout="prev, pager, next"
    @current-change="handleCurrentChange"
    :total="total">
  </el-pagination>

  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="450px">
    <el-form :model="editItem" label-width="80px">
      <el-form-item label="姓名">
        <el-input v-model="editItem.psnName" :disabled="dialogTitle == '编辑人员'"></el-input>
      </el-form-item>
      <el-form-item label="手机">
        <el-input v-model="editItem.mobile" :disabled="dialogTitle == '编辑人员'"></el-input>
      </el-form-item>
      <el-form-item label="昵称" v-if="dialogTitle == '编辑人员'">
        <el-input v-model="editItem.memberName" :disabled="dialogTitle == '编辑人员'"></el-input>
      </el-form-item>
      <el-form-item label="工号">
        <el-input v-model="editItem.employeeNum" :disabled="dialogTitle == '编辑人员'"></el-input>
      </el-form-item>
      <el-form-item label="角色" v-if="dialogTitle == '编辑人员'">
        <el-checkbox-group v-model="editItem.checkList">
          <el-checkbox label="普通成员"></el-checkbox>
          <el-checkbox label="印章保管员"></el-checkbox>
          <el-checkbox label="成员管理员"></el-checkbox>
          <el-checkbox label="模板管理员"></el-checkbox>
          <el-checkbox label="企业法定代表人" disabled></el-checkbox>
          <el-checkbox label="企业管理员" disabled></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="所属机构" v-if="dialogTitle == '编辑人员'">
        <el-input v-model="editItem.orgName" :disabled="dialogTitle == '编辑人员'"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="save()">保 存</el-button>
    </span>
  </el-dialog>
</el-card>
</template>

<script>
import { 
  addUser,
  updateUser,
  deleteUser,
  fetchBusinessMember
} 
from '@/api/api';
export default {
  name:"StaffPage",
  data() {
    return {
      profile: {
        userId: "0",
        orgId: "",
        userName: "",
        orgName: "",
        psnId: ""
      },
      users: [],
      multipleSelection:[],
      searchItem: {
        staff: '',
        department: '',
        role: '',
      },
      editItem: {
        id: 0,
        psnName: '',
        memberName: '',
        mobile: '',
        employeeNum: '',
        weight: 0,
        orgName: '',
        role: '',
        checkList: []
      },
      dialogTitle: '',
      dialogVisible: false,
      departments: [],
      roles: [
        {
						label: "普通成员",
						value: '1'
					},
					{
						label: "印章保管员",
						value: '2'
					},
					{
						label: "成员管理员",
						value: '3'
					},
					{
						label: "模板管理员",
						value: '4'
					},
					// {
					// 	label: "企业法定代表人",
					// 	value: '98'
					// },
					// {
					// 	label: "企业管理员",
					// 	value: '99'
					// },
      ],
      orgId: 1,
      orgName: '南京百市通数字科技有限公司',
      page: 1,
      limit: 10,
      total: 0
    }
  },

  mounted() {
    this.getBusinessMember();
  },

  methods: {
    async getBusinessMember() {
      this.profile.orgId = localStorage.getItem("orgId")||"";
      var params = {
        "orgId": this.profile.orgId,
        "page": this.page,
        "limit": this.limit
      };
      try {
        let result = await fetchBusinessMember(params);

        if (result.data.code == 0) {
          this.users = [];
          this.users = result.data.data.data;
          this.total = result.data.data.total;
        }
      }catch(err){
        console.log(err.response.data.message);
        this.$message.error(err.response.data.message);
      }
    },
    handleCurrentChange(val) {
        this.page = val;
        this.getBusinessMember();
      },
    // 角色筛选
    filterRole(str) {
      var numberArray = str.split(",");
      let numberToWordMap = {
        "1": "普通成员",
        "2": "印章保管员",
        "3": "成员管理员",
        "4": "模板管理员",
        // "98": "企业法定代表人",
        // "99": "企业管理员"
      };
      let convertedWords = [];
      for (let i = 0; i < numberArray.length; i++) {
        let number = numberArray[i];
        if (numberToWordMap[number]) {
          convertedWords.push(numberToWordMap[number]);
        }
      }
      let joinedWords = convertedWords.join(",");

      return joinedWords;
    },
    find(){
      
    },
    reset(){
      this.searchItem.staff = "";
      this.searchItem.department = "";
      this.searchItem.role = "";
      this.getUsers();
    },

    save() {
      if(this.editItem.action == "add") {
        const data = {
          "orgId": localStorage.getItem("orgId"), 
					"members":[
						{
              "mobile":this.editItem.mobile,
              "memberName":this.editItem.memberName,
              "employeeNum":this.editItem.employeeNum
						}
					]
        };
        addUser(data).then((res) =>{
          this.dialogVisible = false;
          if(res.data.code == 0) {
            this.$message({message: '添加成功',type: 'success'});
            this.getBusinessMember();
          }
        }).catch((err)=> {
          this.dialogVisible = false;
          this.$message.error(err.response.data.message);
        });
      } else {
        const data = {
          "roles": this.editItem.checkList.join(","),
          "memberPsnId": this.editItem.psnId,
          "orgId" : localStorage.getItem("orgId"),
        };
        updateUser(data).then((res) =>{
          this.dialogVisible = false;
          if(res.data.code == 0) {
            this.$message({message: '更新成功',type: 'success'});
            this.getBusinessMember();
          }
        }).catch((err)=> {
          this.dialogVisible = false;
          this.$message.error(err.response.data.message);
        });
      }
    },
    
    remove(row) {
      console.log(row)
      event.stopPropagation();
      this.$confirm("您确定要删除【" + row.psnName + "】吗？", '删除部门', {
          confirmButtonText: '确 定',
          cancelButtonText: '取 消',
          type: 'warning'
        }).then(() => {
          
          deleteUser(localStorage.getItem("orgId"), row.psnId).then(() =>{
            this.$message({message: '删除成功',type: 'success'});
            this.getBusinessMember();
          }).catch((err)=> {
            this.$message.error(err.response.data.message);
          });
        }).catch((err) => {
          if (err == "cancel") {  
            return
          }
          this.$message.error(err);
        })
    },

    edit(staff) {
      event.stopPropagation();   
      this.editItem.id = staff.id; 
      this.editItem.psnName = staff.psnName;
      this.editItem.memberName = staff.memberName;
      this.editItem.mobile = staff.psnAccount.accountMobile;
      this.editItem.employeeNum = staff.employeeNum;
      this.editItem.psnId = staff.psnId;
      var numberArray = staff.role.split(",");
      let numberToWordMap = {
        "1": "普通成员",
        "2": "印章保管员",
        "3": "成员管理员",
        "4": "模板管理员",
        // "98": "企业法定代表人",
        // "99": "企业管理员"
      };
      this.editItem.checkList = [];
      for (let i = 0; i < numberArray.length; i++) {
        let number = numberArray[i];
        if (numberToWordMap[number]) {
          this.editItem.checkList.push(numberToWordMap[number]);
        }
      }

      this.editItem.orgName = localStorage.getItem("orgName")||"";

      this.editItem.action ="edit",
      this.dialogTitle = '编辑人员';
      this.dialogVisible = true;
    },
    add() {
      event.stopPropagation();   
      this.editItem.id = ""; 
      this.editItem.psnName = "";
      this.editItem.memberName = "";
      this.editItem.mobile = "";
      this.editItem.employeeNum = "";
      this.editItem.psnId = "";
      this.editItem.checkList = [];
      this.editItem.orgName = "";

      this.editItem.action ="add",
      this.dialogTitle = '添加人员';
      this.dialogVisible = true;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  },
}
</script>